import s from './style.module.scss';

import Input1 from '../../../components/input';
import SubmitBtn3,{SubmitBtn4} from '../../../components/submit3';

import TextAr from '../../../components/textarea';

import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';
import { loaderPostFetch } from '../util';

import { useRef, useState, useEffect } from 'react';
import Notif from '../../../components/notif';

import { useActionData, useSubmit } from 'react-router-dom';

export async function saction({ request, params }) {
  //loader will fetch details
  const formData = await request.formData();

  const password = formData.get('c_pwd');
  const npassword = formData.get('n_pwd');
  const cnpassword = formData.get('con_pwd');
  const errors = {};
  // validate the fields
  if (npassword != cnpassword) {
    errors.failed = 'Password Mismatch';
  } /* 
  if (typeof password !== "string" || password.length < 6) {
    errors.password = "Password must be > 6 characters";
  } */
  // return data if we have errors
  if (Object.keys(errors).length) {
    return errors;
  }

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const contact = await loaderPostFetch(`api/users.php`, formData);

  return contact;
}

/*

export async function mpcloader({ params }) {
  const formData = new FormData();
  formData.append('getmpcform', 'getmpcform');
 
  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  } 
  const res = await loaderPostFetch(`api/users.php`, formData);

  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params,...res };
}
 
*/

export async function ploader({ params }) {
  const formData = new FormData();
  formData.append('getprofile', 'getprofile');

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const profile = await loaderPostFetch(`api/users.php`, formData);

  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, profile };
}

export default function SettingsIndex() {
  const { profile } = useLoaderData();

  let actionData = useActionData();

  //disabled
  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  useEffect(() => {
    /*console.log({ actionData });*/
    if (actionData) {
      let s = actionData;
      if (s?.failed) {
        sN({ ...n, display: true, type: 'error', msg: s?.failed });
      } else {
        if (s?.status) {
          if (s?.status == 'success') {
            sN({ ...n, display: true, type: 'success', msg: 'Action Successful!' });
          } else {
            sN({ ...n, display: true, type: 'error', msg: 'Something went wrong!' });
          }
        }
      }
      setTimeout(() => {
        sN({ ...n, display: false, type: 'success', msg: 'Copied to clipboard' });
      }, 5000);
      /*sN({ display: true, type: 'success', msg: `${s?.message1}` });
          setTimeout(() => {
            sN({ display: false, type: 'success', msg: `` }); 
          }, 5000);*/
    }
  }, [actionData]);
  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
  };

  const [form1Disabled, sForm1Disabled] = useState(true);
  const [form2Disabled, sForm2Disabled] = useState(true);

  const [form2, sForm2] = useState({});
  const validateForm2 = () => {};
  useEffect(() => {
    if (Object.keys(form2).length == 3) {
      if (form2?.n_pwd === form2?.con_pwd && form2?.con_pwd?.length > 4) {
        sForm2Disabled(false);
      } else {
        sForm2Disabled(true);
      }
    } else {
      sForm2Disabled(true);
    }
  }, [form2]);

  const resetpin=async ()=>{

    sN({ ...n, display: true, type: 'success', msg: 'Please Wait' });
     
    
    const formData = new FormData();//await request.formData();
  formData.append("action","code");
  //const updates = Object.fromEntries(formData);

    let tok = window.localStorage.getItem('baUid');
    if (tok != null) {
      formData.append('token', tok);
    }
  //updates['action'] = 'code';
  //let contact;
  //const contact = await

  /* 
    const formData = new FormData();
    formData.append('getprofile', 'getprofile');

    loaderPostFetch(`api/users.php?crud=resetpin`, rData)
  */
  const contact = await loaderPostFetch(`api/users.php?crud=userforgotpin`, formData)
    .then((c)=>{
        //sactionData(c);
        //setLoading(false);
        sN({ ...n, display: true, type: 'success', msg: 'We have sent a link to reset your PIN to your registered email address. Please check your inbox.' });
          setTimeout(() => {
            sN({ display: false, type: 'success', msg: `` }); 
          }, 5000);
      })
      .catch((e)=>{
        //setLoading(false);
        sN({ ...n, display: true, type: 'error', msg: 'Something went wrong.' });
        setTimeout(() => {
            sN({ display: false, type: 'success', msg: `` }); 
          }, 5000);
      });
  } 


  const [form3Disabled, sForm3Disabled] = useState(true);

  const [form3, sForm3] = useState({});
  const validateForm3 = () => {};
  useEffect(() => {
    if (Object.keys(form3).length == 3) {
      if (form3?.n_pwd === form3?.con_pwd && form3?.con_pwd?.length == 4) {
        sForm3Disabled(false);
      } else {
        sForm3Disabled(true);
      }
    } else {
      sForm3Disabled(true);
    }
  }, [form3]);


  const [pat2, setPat2] = useState(`.{6,6}|[0-9]*`);

  function escapeRegExp(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }
    function handleChange(e) {
        //setValue(e.target.value);
        if(!e.target.value) return;

  // if non numeric
  let isNum = e.target.value[e.target.value.length - 1].match(/[0-9]/g);
  if(!isNum) e.target.value = e.target.value.substring(0, e.target.value.length - 1);


  setPat2(escapeRegExp(e.target.value));

    }
    function handleChange1(e) {
        //setValue(e.target.value);
        if(!e.target.value) return;

  // if non numeric
  let isNum = e.target.value[e.target.value.length - 1].match(/[0-9]/g);
  if(!isNum) e.target.value = e.target.value.substring(0, e.target.value.length - 1);
 
    }

  return (
    <>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      <div>
        <div className={s.h}>Settings</div>
        <div className={s.sh}>Email</div>
        <div className={s.p1}>
          Your email address is an essential part of your
          <br /> sign in process.
        </div>

        <Form method="post">
          <input type="hidden" name="updateemail" value="updateemail" />

          <Input1
            name="email"
            value={profile?.data?.email}
            label=""
            onChange={(e) => {
              //is valid email
              if (validateEmail(e.target.value)) {
                sForm1Disabled(false);
              } else {
                sForm1Disabled(true);
              }
            }}
          />

          <SubmitBtn3 label="Save " disabled={form1Disabled} />
        </Form>

        <div className={s.sh}>Passcode</div>
        <div className={s.p1}>
          Edit your sign-in passcode.
          <br />
        </div>

        <Form method="post">
          <input type="hidden" name="updatepwd" value="updatepwd" />

          <Input1
            name="c_pwd"
            onChange={(e) => {
              sForm2({ ...form2, c_pwd: e.target.value });
            }}
            label="Current Passcode"
            placeholder="Enter Passcode"
            type="password"
            maxlength={6} pattern=".{6,6}|[0-9]*" oninput={handleChange1} required={true} 
          />
          {/*
<Input2 name="password" 
type="password" placeholder="Create passcode (6 digits)" hasIcon="show" toggleIconWith="hide" />
        

        <Input2 type="password" 
        placeholder="Confirm Passcode" hasIcon="show" toggleIconWith="hide" />
*/}
          <Input1
            name="n_pwd"
            onChange={(e) => {
              sForm2({ ...form2, n_pwd: e.target.value });
            }}
            maxlength={6} pattern=".{6,6}|[0-9]*" oninput={handleChange} required={true} title="Passcode must be 6 digits" 

            label="Enter new passcode"
            placeholder="Enter new passcode"
            type="password"
          />

          <Input1
            name="con_pwd"
            onChange={(e) => {
              sForm2({ ...form2, con_pwd: e.target.value });
            }}
            maxlength={6} pattern={pat2} title="Confirm Password must be 6 digits and same as Passcode"  required={true} 
        
            label="Confirm new passcode"
            placeholder="Retype new passcode"
            type="password"
          />

          <SubmitBtn3 label="Save " disabled={form2Disabled} />
        </Form>

<br/>
        <div className={s.sh}>PIN</div>
        <div className={s.p1}>
          Edit your transaction PIN.
          <br />
        </div>

        <Form method="post">
          <input type="hidden" name="supdatepin" value="supdatepin" />

          <Input1
            name="c_pwd"
            onChange={(e) => {
              sForm3({ ...form3, c_pwd: e.target.value });
            }}
            label="Current PIN"
            placeholder="Enter PIN"
            type="password"
          />

          <Input1
            name="n_pwd"
            onChange={(e) => {
              sForm3({ ...form3, n_pwd: e.target.value });
            }}
            label="Enter new PIN"
            placeholder="Enter new PIN"
            type="password"
          />

          <Input1
            name="con_pwd"
            onChange={(e) => {
              sForm3({ ...form3, con_pwd: e.target.value });
            }}
            label="Confirm new PIN"
            placeholder="Retype new PIN"
            type="password"
          />
          <div className={s?.btn2}>
            <SubmitBtn3 label="Save " disabled={form3Disabled} />
            <SubmitBtn4 label="Reset PIN" disabled={false} onClick={()=>{
              resetpin();
            }}  />
          </div>
        </Form>

      </div>
    </>
  );
}
